import { useTranslations } from 'next-intl'
import toasters from '../../../locales/fr/toasters.json'
import { isErrorWithCode } from '../utils/queryUtils'
import { ToastData, useToast } from '../v2/shared/components/Toaster/ToasterProvider'

export type ToastersKeys = keyof (typeof toasters)['toasters']

export const stringToToasterKeyValidator = (key: string): ToastersKeys | undefined => {
    if (Object.keys(toasters['toasters']).includes(key)) {
        return key as ToastersKeys
    }
    return
}

const toastTypeToIntent = {
    brand: 'info',
    positive: 'success',
    negative: 'error',
    warning: 'warning'
} as const satisfies Record<string, ToastData['intent']>

export const deprecated_useSetToast = (): ((
    key: ToastersKeys,
    type: keyof typeof toastTypeToIntent,
    errorMessage?: string
) => void) => {
    const t = useTranslations('toasters')
    const { showToast } = useToast()

    return (key: ToastersKeys, type: keyof typeof toastTypeToIntent, errorMessage?: string) => {
        return showToast({
            title: t(`${key}.${type}.title` as any),
            ...(errorMessage
                ? { description: t(`${key}.${type}.details` as any, { message: errorMessage }) }
                : { description: t(`${key}.${type}.description` as any) }),
            intent: toastTypeToIntent[type]
        })
    }
}

const hasToasterTranslation = (code: string): boolean => {
    return Object.keys(toasters['toasters']).includes(code)
}

export const useSetToast = () => {
    const { showToast } = useToast()
    const toasterTranslations = useTranslations('toasters')

    return (props: ToastData, error?: any) => {
        if (isErrorWithCode(error) && hasToasterTranslation(error.code)) {
            showToast({
                title: toasterTranslations(`${error.code}.negative.title` as any),
                description: toasterTranslations(`${error.code}.negative.description` as any),
                intent: 'error'
            })
            return
        }

        showToast(props)
    }
}
